import {httpGet,httpPut,httpDelete,httpPost} from '../../../../util/request.js';
import appConfig from '../../../../config';

export default class SaleHeadApi{

    static GET_SALEHEAD_WITH_DT_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/jg/sale/saleHeadWithDt";
	
	static getSaleHead(params){
		return httpGet(SaleHeadApi.GET_SALEHEAD_WITH_DT_API_URL,params);
    }

    
}